import type { FC } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { JSONView } from "@/admin/features/queueJobs/domains";
import type { PaymentShowData } from "@/admin/entities/payments";

interface PaymentJsonPanelsProps {
  payment: PaymentShowData;
}

const panels: { label: string; key: "metadata" | "providerPaymentData" }[] = [
  { label: "Метаданные платежа", key: "metadata" },
  { label: "Данные провайдера", key: "providerPaymentData" },
];

/**
 * JSON-панели платежа, как в легаси (PaymentDetails JSONView): метаданные
 * и сырой ответ провайдера. Пустая панель не рисуется.
 */
export const PaymentJsonPanels: FC<PaymentJsonPanelsProps> = ({ payment }) => (
  <>
    {panels.map(({ label, key }) => {
      const value = payment[key] as unknown;
      if (!value || typeof value !== "object") return null;

      return (
        <Card key={key}>
          <CardContent>
            <Typography variant="h6" component="h3" sx={{ mb: 1 }}>
              {label}
            </Typography>
            <JSONView src={value} />
          </CardContent>
        </Card>
      );
    })}
  </>
);
